// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** Mixins **/
/** Vars (common) **/
/** app colors **/
/** Vars (MuiAlert) **/
/** main classes **/
.nibCard_old-container__Clf0g {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  width: 100%;
}
.nibCard_old-container__Clf0g.nibCard_wrap__LB3Dd {
  flex-wrap: wrap;
}
.nibCard_old-container__Clf0g .nibCard_box__b00gR.nibCard_col__ZgSJO {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0 10px;
}
.nibCard_old-container__Clf0g .nibCard_box__b00gR.nibCard_col__ZgSJO > div {
  width: 100%;
}
.nibCard_old-container__Clf0g .nibCard_box__b00gR.nibCard_row__zuwat {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.nibCard_old-container__Clf0g form {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  width: 100%;
}
.nibCard_old-container__Clf0g form > .nibCard_box__b00gR.nibCard_col__ZgSJO {
  flex-basis: 33.33%;
}
@media screen and (min-width: 2560px) {
  .nibCard_old-container__Clf0g form > .nibCard_box__b00gR.nibCard_col__ZgSJO {
    flex-basis: 0%;
    margin-right: 2em;
  }
}

@media screen and (max-width: 580px) {
  .nibCard_old-container__Clf0g, .nibCard_col__ZgSJO, form {
    padding: 5px;
  }
}
@media screen and (max-width: 450px) {
  .nibCard_old-container__Clf0g, .nibCard_col__ZgSJO, form {
    padding: 0px;
  }
}
.nibCard_text-overflow-hidden__jcBm- {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nibCard_icon__SPQvP {
  color: var(--accent-color);
}

.nibCard_richtext-output-wrap__CbVqb .nibCard_se-video-container__zRh9v figure {
  padding-bottom: 0 !important;
}

.nibCard_cardWrap__Ab8Ft {
  padding: 5px 10px;
  margin: 10px;
  background-color: #1B1B1B;
  max-width: 465px;
  min-width: 320px;
  position: relative;
  border-radius: 12px;
}
.nibCard_cardWrap__Ab8Ft .nibCard_card__r4w4p {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.nibCard_cardWrap__Ab8Ft .nibCard_header__xqmHv {
  padding: 20px;
  padding-right: 40px;
  padding-bottom: 10px;
}
.nibCard_cardWrap__Ab8Ft .nibCard_header__xqmHv h3 {
  font-weight: 500;
}
.nibCard_cardWrap__Ab8Ft .nibCard_header__xqmHv p {
  font-weight: 300;
  color: rgba(255, 255, 255, 0.6);
  font-size: 90%;
}

@media screen and (max-width: 580px) {
  .nibCard_cardWrap__Ab8Ft {
    margin: 10px 5px;
  }
  .nibCard_cardWrap__Ab8Ft .nibCard_header__xqmHv {
    padding: 10px;
  }
}
@media screen and (max-width: 450px) {
  .nibCard_cardWrap__Ab8Ft {
    margin: 10px 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/sass/_settings.sass","webpack://./src/components/common/NibCard/nibCard.module.sass"],"names":[],"mappings":"AAAA,aAAA;AAeA,oBAAA;AAgBA,iBAAA;AA0BA,sBAAA;AAGA,mBAAA;AACA;EA3DE,aAAA;EACA,mBA4DM;EA3DN,8BA2DW;EA1DX,uBA0D0B;EAC1B,kBAAA;EACA,WAAA;ACrDF;ADsDE;EACE,eAAA;ACpDJ;ADsDI;EAnEF,aAAA;EACA,sBAmEU;EAlEV,2BAkEkB;EAjElB,uBAiE8B;EAC1B,eAAA;ACjDN;ADkDM;EACE,WAAA;AChDR;ADiDI;EAxEF,aAAA;EACA,mBAwEU;EAvEV,2BAuEe;EAtEf,uBAsE2B;EACvB,WAAA;AC5CN;AD6CE;EACE,aAjDK;EA3BP,aAAA;EACA,mBA4EQ;EA3ER,2BA2Ea;EA1Eb,uBA0EyB;EACvB,kBAAA;EACA,eAAA;EACA,WAAA;ACxCJ;ADyCI;EACE,kBAAA;ACvCN;ADwCM;EAFF;IAGI,cAAA;IACA,iBAAA;ECrCN;AACF;;ADsCA;EAEE;IACE,YAFO;EClCT;AACF;ADoCA;EAEE;IACE,YAFO;ECjCT;AACF;ADoCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AClCF;;ADoCA;EACE,0BAtFO;ACqDT;;ADqCI;EACE,4BAAA;AClCN;;AAzEA;EACI,iBAAA;EACA,YAAA;EACA,yBDsByB;ECrBzB,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA4EJ;AAzEI;EACI,WAAA;EDXN,aAAA;EACA,sBCWY;EDVZ,2BCUoB;EDTpB,uBCSgC;AA8ElC;AA7EI;EACI,aDaC;ECZD,mBAAA;EACA,oBAAA;AA+ER;AA9EQ;EACI,gBAAA;AAgFZ;AA/EQ;EACI,gBAAA;EACA,+BAAA;EACA,cAAA;AAiFZ;;AA/EA;EACI;IACI,gBAAA;EAkFN;EAjFM;IACI,aAAA;EAmFV;AACF;AAlFA;EACI;IACI,gBAAA;EAoFN;AACF","sourcesContent":["/** Mixins **/\n=flex($der, $justy, $align)\n  display: flex\n  flex-direction: $der\n  justify-content: $justy\n  align-items: $align\n\n=shadow()\n  box-shadow: -5px 5px 10px 0px rgba(#000, .35)\n\n=staticHeight($height)\n  min-height: $height\n  max-height: $height\n  height: $height\n\n/** Vars (common) **/\n$main: #2F2F2F\n$main_background: #191818\n$accent: var(--accent-color)\n$accent_text: var(--accent-text-color)\n$accent_r: var(--accent-color-r)\n$accent_g: var(--accent-color-g)\n$accent_g10: var(--accent-color-g10)\n$accent_b: var(--accent-color-b)\n$text: #cecece\n$error: #f44336\n$success: rgb(102, 187, 106)\n$container_background_color: #1B1B1B\n$container_item_background_color: #212121\n$gutter: 20px\n\n/** app colors **/\n$soft_teal: #84aaaf\n$fiery_red: #ff3131\n$muted_red: #e85a4f\n$app_red: #B83336\n$soft_creamy: #f5e8dd\n$light_gray: #535353\n$golden_yellow: #ffc107\n$orange: #ffa725\n$app_orange: #DB890E\n$warm_orange: #e3a869\n$faded_pink: #d69fa2\n$purple: #8868a3\n$app_purple: #7E51A3\n$light_blue: #79a8d1\n$app_green: #16962F\n$retro_green: #4a7c59\n$deep_blue: #406ca8\n\n$main_block_top_padding: 130px\n$main_block_top_padding_s: 70px\n$header_height: 120px\n$sidebar_width: 320px\n\n$table_row_height: 55px\n\n/** Vars (MuiAlert) **/\n$MuiAlert_main_color: rgb(166, 213, 250)\n\n/** main classes **/\n.old-container\n  //padding: $gutter\n  +flex(row, space-between, flex-start)\n  position: relative\n  width: 100%\n  &.wrap\n    flex-wrap: wrap\n  .box\n    &.col\n      +flex(column, flex-start, flex-start)\n      padding: 0 calc($gutter/2)\n      > div\n        width: 100%\n    &.row\n      +flex(row, flex-start, flex-start)\n      width: 100%\n  form\n    padding: $gutter\n    +flex(row, flex-start, flex-start)\n    position: relative\n    flex-wrap: wrap\n    width: 100%\n    > .box.col\n      flex-basis: 33.33%\n      @media screen and ( min-width: 2560px )\n        flex-basis: 0%\n        margin-right: 2em\n\n@media screen and ( max-width: 580px )\n  $gutter: 5px\n  .old-container, .col, form\n    padding: $gutter\n@media screen and ( max-width: 450px )\n  $gutter: 0px\n  .old-container, .col, form\n    padding: $gutter\n\n.text-overflow-hidden\n  overflow: hidden\n  text-overflow: ellipsis\n  white-space: nowrap\n\n.icon\n  color: $accent\n\n.richtext-output-wrap\n  .se-video-container\n    figure\n      padding-bottom: 0 !important\n","@import '../../../sass/settings'\n\n.cardWrap\n    padding: 5px 10px\n    margin: 10px\n    background-color: $container_background_color\n    max-width: 465px\n    min-width: 320px\n    position: relative\n    border-radius: 12px\n\n\n    .card\n        width: 100%\n        +flex(column, flex-start, flex-start)\n    .header\n        padding: $gutter\n        padding-right: $gutter * 2\n        padding-bottom: calc($gutter/2)\n        h3\n            font-weight: 500\n        p\n            font-weight: 300\n            color: rgba(#fff, .6)\n            font-size: 90%\n\n@media screen and ( max-width: 580px )\n    .cardWrap\n        margin: 10px 5px\n        .header\n            padding: 10px\n\n@media screen and ( max-width: 450px )\n    .cardWrap\n        margin: 10px 0px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"old-container": `nibCard_old-container__Clf0g`,
	"wrap": `nibCard_wrap__LB3Dd`,
	"box": `nibCard_box__b00gR`,
	"col": `nibCard_col__ZgSJO`,
	"row": `nibCard_row__zuwat`,
	"text-overflow-hidden": `nibCard_text-overflow-hidden__jcBm-`,
	"icon": `nibCard_icon__SPQvP`,
	"richtext-output-wrap": `nibCard_richtext-output-wrap__CbVqb`,
	"se-video-container": `nibCard_se-video-container__zRh9v`,
	"cardWrap": `nibCard_cardWrap__Ab8Ft`,
	"card": `nibCard_card__r4w4p`,
	"header": `nibCard_header__xqmHv`
};
export default ___CSS_LOADER_EXPORT___;
